import { SelectOption } from '../types/option';
import { fcMovideskHttpClient } from './httpClient';

type StoreTypeDto = { id: string; name: string };
type StoreTypesResponseDto = {
  customFieldId: number;
  customFieldRuleId: number;
  options: StoreTypeDto[];
};

export async function getStoreTypes(signal?: AbortSignal): Promise<SelectOption[]> {
  const response = await fcMovideskHttpClient.get<StoreTypesResponseDto>('/store-types', {
    signal,
  });

  return response.options.map((storeType) => ({ id: storeType.id, label: storeType.name }));
}
